import crud from './helpers/crud';
import { REQUEST_OUTCOMES, requestTransport } from './helpers/requestTransport';

// Search stays local to the editor; it must not replace the Contacts page or URL.
export const findSenderContacts = async (params, signal) => {
  const result = await requestTransport({
    method: 'GET', url: '/api/v1/sender_contacts', params, signal,
  });
  if (result.outcome === REQUEST_OUTCOMES.cancelled) return null;
  if (result.outcome !== REQUEST_OUTCOMES.success) throw new Error('Could not load contacts. Please try again.');
  return result.value.data;
};

export const saveSenderContact = (recipient, id, sourceFaxId) => crud({
  dispatch: { begin: 'BEGIN_SAVE_SENDER_CONTACT', fail: 'FAILED_SAVE_SENDER_CONTACT', end: 'FINISH_SAVE_SENDER_CONTACT' },
  method: id ? 'PATCH' : 'POST',
  url: `/api/v1/sender_contacts${id ? `/${id}` : ''}`,
  data: { recipient, source_fax_id: sourceFaxId },
  retryOnUnavailable: false,
});

export const senderContactSaved = (contact, record, organizationId) => (dispatch, getState) => {
  if (getState().auth.currentOrganizationId !== organizationId) return;
  dispatch({ type: 'SENDER_CONTACT_SAVED', payload: { contact, record } });
};
